import { GeoJSONPoint } from './geojson';

export enum MediaType {
  DOCUMENT = 'document',
  IMAGE = 'image',
  VIDEO = 'video',
  REPORT = 'report',
}

export enum SubjectType {
  WORK_ORDER = 'workOrder',
  WORK_ORDER_ASSET = 'workOrderAsset',
  WORK_ORDER_TEMPLATE = 'workOrderTemplate',
  INVENTORY_ASSET = 'inventoryAsset',
  FORM_INSTANCE_FIELD = 'formInstanceField',
  FORM_INSTANCE_ASSET = 'formInstanceAsset',
  AI_CHAT_THREAD = 'aiChatThread',
  TEAM_CHAT_CONVERSATION = 'teamChatConversation',
  USER = 'user',
}

export type AllowedFileTypes = {
  mimeTypes: string[];
  extensions: string[];
};

export interface MediaTotalDocumentsType {
  name: 'Documents';
  count: number;
}

export interface MediaTotalImagesType {
  name: 'Photos';
  count: number;
}

export interface MediaTotalVideosType {
  name: 'Videos';
  count: number;
}

export interface FolderItem {
  id: string;
  name: string;
  parentFolderId?: string;
  ancestors?: string[];
  createdDate: number;
  updatedDate: number;
  createdBy: string;
  updatedBy: string;
}

export interface MediaFolderTree {
  id: string;
  name: string;
  children?: MediaFolderTree[];
  ancestors?: string[];
  // used client side to track pending additions
  parentId?: string;
}

export interface MediaFolder {
  id: string;
  name: string;
  subjectId: string;
  parentFolderId?: string;
  ancestors: string[];
  createdDate?: number;
  createdBy: {
    firstName: string;
    lastName: string;
  };
  updatedDate?: number;
  updatedBy?: {
    firstName: string;
    lastName: string;
  };
}

export interface MediaFoldersInput {
  subjectId?: string;
  parentFolderId?: string;
  name?: string;
}

export interface MediaFolderCreateInput {
  name: string;
  subjectId: string;
  parentFolderId?: string;
}

export interface MediaFolderUpdateInput {
  id: string;
  name?: string;
}

export interface MediaFolderMoveInput {
  id: string;
  destParentFolderId: string;
}

export interface MediaBulkMoveInput {
  mediaIds: string[];
  destFolderId: string;
}

export interface Media {
  id: string;
  name: string;
  type: MediaType;
  fileId: string;
  fileExtension: string;
  location: GeoJSONPoint;
  description: string;
  parentSubjectId: string;
  subjectId: string;
  subjectType: SubjectType;
  // Not part of the GraphQL Media type; set on form-instance media returned by the REST API
  fieldId?: string;
  folderId: string;
  folderPath: string[];
  capturedDate?: number;
  createdDate: number;
  createdBy: {
    firstName: string;
    lastName: string;
  };
  updatedDate: number;
  updatedBy: {
    firstName: string;
    lastName: string;
  };
}

export interface MediaConnection {
  totalCount: number;
  media: Media[];
}

export interface MediaConnectionInput {
  page?: number;
  limit?: number;
  ids?: string[];
  parentSubjectId?: string;
  parentSubjectIds?: string[];
  subjectIds?: string[];
  subjectTypes?: SubjectType[];
  folderId?: string;
  type?: MediaType;
  name?: string;
}

export interface MediaUpdateInput {
  id: string;
  name?: string;
  description?: string;
  capturedDate?: number;
}

export interface MediaBulkDeleteInput {
  ids: string[];
}
